<template>
  <div>
    <v-flex xs12 sm12 md12 class="align-content-end"> </v-flex>
    <v-flex xs12 sm12 md12>
      <v-container fill-height fluid>
        <v-layout row wrap>
          <v-flex xs12 sm12 md12>
            <xml-list-table></xml-list-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </div>
</template>
<script>
import xmlListTable from "./xmlListTable.vue";
export default {
  components: { xmlListTable },
};
</script>

<style scoped></style>
